<span>
  <label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
  <p-dropdown
    [class.bf-dropdown-readonly]="props.readonly"
    [filterPlaceholder]="props.filterPlaceholder"
    [filter]="props.filter"
    [filterBy]="props.filterBy ?? props.labelProp"
    [filterFields]="props.filterFields"
    [optionLabel]="props.labelProp"
    [optionValue]="props.valueProp"
    [options]="
      checkIfObservable(props.options) ? (props.options | async) : props.options
    "
    [formControl]="formControl"
    [formlyAttributes]="field"
    [placeholder]="props.placeholder"
    (onChange)="props.change && props.change(field, $event)"
    (onFilter)="props.onFilter && props.onFilter(field, $event)"
    (onFocus)="props.onFocus && props.onFocus(field, $event)"
    (onBlur)="props.onBlur && props.onBlur(field, $event)"
    (onClick)="props.onClick && props.onClick(field, $event)"
    (onShow)="props.onShow && props.onShow(field, $event)"
    (onHide)="props.onHide && props.onHide(field, $event)"
    (onClear)="props.onClear && props.onClear(field, $event)"
    (onLazyLoad)="props.onLazyLoad && props.onLazyLoad(field, $event)"
    [appendTo]="props.appendTo ?? null"
    [overlayOptions]="props.overlayOptions ?? null"
    [id]="field.id"
    [readonly]="props.readonly"
    [editable]="props.editable"
    [showClear]="props.showClear"
    (keydown)="props.keydown ?? onKeyDown($event)"
    ><ng-container *ngIf="props.listItemOptions">
      <ng-template let-option pTemplate="item">
        <basin-list-item
          [primaryLine]="option.primaryLine"
          [secondaryLine]="option.secondaryLine"
          [tertiaryLine]="option.tertiaryLine"
        ></basin-list-item>
      </ng-template>
    </ng-container>
  </p-dropdown>
</span>
